import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodMATUOrLTIAOverlayDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ChangeDeliveryMethodMATUOrLTIAOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodNOOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>This order is under 26 points, so it will be reviewed and booked by Customer Service. Additional freight charges may apply.</p>
                    <div className="noButtonContainer">
						<a onClick={this.closeDialog.bind(this)} href="" className="noButton blueButton">Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={(e) => this.props.continueDeliveryWith(e)}>Ok</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

ChangeDeliveryMethodMATUOrLTIAOverlayDialog = connect(mapStateToProps)(ChangeDeliveryMethodMATUOrLTIAOverlayDialog);
export default ChangeDeliveryMethodMATUOrLTIAOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeDeliveryMethodMATUOrLTIAOverlayDialog.js